import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import Layout from '../components/Layout';
import Loader from '../components/Loader';
import api from '../api';
import useLang from '../hooks/useLang';

export default function BlogDetail() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);
  var { pick } = useLang();

  useEffect(() => {
    setLoading(true);
    api.get(`/blog/${slug}`)
      .then((res) => setPost(res.data))
      .catch(() => setNotFound(true))
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) return <Layout><Loader /></Layout>;
  if (notFound) return (
    <Layout>
      <section className="section container">
        <h1>Post not found</h1>
        <p>This article may have been moved or removed.</p>
        <Link to="/blog" className="btn btn-primary">Back to Blog</Link>
      </section>
    </Layout>
  );

  return (
    <Layout>
      <article className="section">
        <div className="container" style={{ maxWidth: 760 }}>
          <span className="eyebrow">{pick(post, 'category') || post.category}</span>
          <h1>{pick(post, 'title')}</h1>
          {post.coverImage && <img src={post.coverImage} alt={pick(post, 'title')} style={{ width: '100%', borderRadius: 16, marginBottom: 24 }} />}
          <div style={{ whiteSpace: 'pre-wrap', lineHeight: 1.8 }}>{pick(post, 'content')}</div>
        </div>
      </article>
    </Layout>
  );
}
